<app-global-data (OnCountryListReady)="OnCountryList($event)"></app-global-data>

<app-alert-box-component (OnButtonClick)="onAlertButtonClick($event)" (OnAlertClose)="closeAlert($event)"
  (OnAlertVisibility)="alertVisibility($event)" [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" [alertBodyText]="alertBodyText" [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText" [data]="alertBoxData" [bAlert]="bAlert"></app-alert-box-component>


<div *ngIf="!decisionSaveModel" class="save-model">
  <!-- <c-navbar>
    <c-container>
        <div class="row">
            <div class="col">
                <button cBgColor="primary" cButton (click)="create()">
                    Create
                </button>
            </div>
            </div>
    </c-container>
  </c-navbar> -->
  <c-smart-table [columnSorter]="true" [columns]="columns" [columnFilter]="true" [itemsPerPageSelect]="true"
    [itemsPerPage]="10" [items]="decisionTable" [tableBodyProps]="{ align: 'middle' }"
    [tableProps]="{ hover: true, striped: true, responsive: true }" (rowClick)="rowSelected($event); " clickableRows
    header pagination>

  </c-smart-table>
</div>
<div *ngIf="decisionSaveModel" class="save-model">

  <div class="main-height">
    <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
      <c-container fluid>
        Update Decision
        <button [cNavbarToggler]="toolbarCollapseRef"></button>
        <div #toolbarCollapseRef="cCollapse" navbar cCollapse>
          <c-navbar-nav class="me-auto mb-2 mb-lg-0">

          </c-navbar-nav>
          <form cForm class="d-flex" role="search">
            <button cTooltip="Go Back" cTooltipPlacement="top" style="margin: 5px;" cButton
              (click)="goBackToSearchScreen()"><svg cIcon name="cilChevronDoubleLeft"></svg></button>
            <button cTooltip="Save Customer" cTooltipPlacement="top" style="margin: 5px;" cButton
              (click)="submit()"><svg cIcon name="cilSave"></svg></button>
          </form>
        </div>
      </c-container>
    </c-navbar>
    <div class="row g-2 pt-4">
      <div class="container">
        <form [formGroup]="decisionTableForm">
          <div class="row">
            <div class="col-md-6">
              <label>Parameter</label>
              <div class="table-view">

                <input [readonly]="true" class="form-control" type="text" formControlName="paramerID" />
                <!-- <select  cSelect id="decisionRule" name="decisionRule" formControlName="paramerID">
                    <option *ngFor="let Parameter of DecisionParameters"  [value]="Parameter.id">{{Parameter.name}}</option>
                  </select> -->
              </div>
              <label>Decision Rule</label>
              <div class="table-view">
                <input [readonly]="true" type="text" class="form-control" formControlName="decisionRule" />
                <!-- <select  cSelect id="decisionRule" name="decisionRule" formControlName="decisionRule">
                    <option *ngFor="let rule of DecisionRules"  [value]="rule.id">{{rule.description}}</option>
                  </select> -->
              </div>
              <label>Decision Type</label>
              <div class="table-view">

                <input [readonly]="true" class="form-control" type="text" formControlName="decisionType" />
                <!-- <select  cSelect id="decisionType" name="decisionType" formControlName="decisionType">
                    <option *ngFor="let type of DecisionTypes"  [value]="type.id">{{type.dataType}}</option>
                  </select> -->
              </div>
              <label>Allow Onboarding</label>
              <div class="table-view">
                <select cSelect id="inputRole" name="inputRole" formControlName="allowOnboarding">
                  <!-- <option value="false">InActive</option> -->
                  <option selected value="true">Active</option>
                </select>

              </div>
            </div>
            <div class="col-md-6">
              <label>Decision Value</label>
              <div class="table-view" *ngIf="getRowValueData?.paramerID != 'Income'">
              <input type="text" [readonly]="true" class="form-control" value="{{getRowValueData?.decisionValue}}" />
              </div>
              <div class="table-view" *ngIf="getRowValueData?.paramerID != 'Income'">
                <!-- <select [(ngModel)]="getRowValueData.decisionValue"  cSelect id="multiselectUser" name="inputRole" formControlName="decisionValue"  multiple="multiple">
                    <option *ngFor="let field of dropdownvalue" [value]="field" >
                      {{field}}</option>
                  
                </select> -->
                <select (ngModelChange)="onChange($event)" class="multiple"  name="selectedCars" formControlName="decisionValue"    multiple="multiple">
                  <option *ngFor="let field of countryFullValue" [value]="field.id">{{field.countryName}}</option>
              </select>
             
                <!-- <c-multi-select formControlName="decisionValue" multiple>
                  <c-multi-select-option *ngFor="let field of countryFullValue "
                    [value]="field.id">{{field.countryName}}</c-multi-select-option>

                </c-multi-select> -->
              </div>
              <div class="table-view" *ngIf="getRowValueData?.paramerID === 'Income'">
               
                <select cSelect id="decisionValue" name="decisionValue" formControlName="decisionValue">
                  <option *ngFor="let Parameter of DecisionParametersSources" [value]="Parameter.value">
                    {{Parameter.value}}</option>
                </select>
              </div>
              
            </div>
            </div>
            <div class="row">
            <div class="col-md-6">
              
            </div>

            <div class="col-md-6">
             
            </div>
            </div>
            
           <div class="row">
           
            <div class="col-md-6">
              
            </div>
            <!-- <div class="col-md-6"><div *ngIf="decisionTableForm.value.dcecisionValue" class="lds-dual-ring"></div></div> -->
          </div>
        </form>
      </div>
    </div>
  </div>
</div>